import { Button } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import React, { memo } from "react";

const useStyles = makeStyles((theme) => ({
  root: { fontWeight: "bold", margin: 0, padding: 0, textTransform: "none" },
}));

const StatusLabel = (props) => {
  const classes = useStyles();
  const statusList = {
    D: "Draft",
    A: "Active",
    I: "In Active",
    R: "Cancel",
    P: "ผ่าน",
    N: "ไม่ผ่าน",
  };
  const cursor = props.cursor === undefined ? 'pointer' : props.cursor;

  switch (props.statusCode) {
    case "D":
      return (
        <Button
          className={classes.root}
          style={{
            color: "#AC7E07",
            backgroundColor: "#FFBC0E",
            cursor: cursor,
          }}
        >
          {statusList[props.statusCode]}
        </Button>
      );
    case "A":
      return (
        <Button
          className={classes.root}
          style={{
            color: "#0B6838",
            backgroundColor: "#CDFFE4",
            cursor: cursor,
          }}
        >
          {statusList[props.statusCode]}
        </Button>
      );
    case "I":
      return (
        <Button
          className={classes.root}
          style={{
            color: "#000",
            backgroundColor: "#dedede",
            cursor: cursor,
          }}
        >
          {statusList[props.statusCode]}
        </Button>
      );
    case "R":
      return (
        <Button
          className={classes.root}
          style={{
            color: "#FF0000",
            backgroundColor: "#FFC6C6",
            cursor: cursor,
          }}
        >
          {statusList[props.statusCode]}
        </Button>
      );
    case "P":
      return (
        <Button
          className={classes.root}
          style={{
            color: "#0B6838",
            backgroundColor: "#CDFFE4",
            cursor: cursor,
          }}
        >
          {statusList[props.statusCode]}
        </Button>
      );
    case "N":
      return (
        <Button
          className={classes.root}
          style={{
            color: "#FF0000",
            backgroundColor: "#FFC6C6",
            cursor: cursor,
          }}
        >
          {statusList[props.statusCode]}
        </Button>
      );
    default:
      return <span>-</span>;
  }
};

export default memo(StatusLabel);
